/**
 * Created by mykurisu on 2017/9/15.
 */
import React from 'react'
import {browserHistory} from 'react-router'
import {
    Tab,
    TabBody,
    NavBar,
    NavBarItem,
} from 'react-weui';
import BoughtList from './BoughtList'
import ListenedList from './ListenedList'
import { isQQ, isAlipay } from '../../utils'
import '../../styles/record/RecordPage.css'


class BoughtPage extends React.Component {

    constructor() {
        super();
        this.state = {
            tab: 0,
            boughtTop: 0,
            listenTop: 0
        }
    }

    componentDidMount() {
        //如果从我的微课url直接进来就没有this.props.route了 //给的我的微课/我买的课用的
        if(!this.props.route){
            return
        }
        let {path} = this.props.route;
        if (path === '/account/listened'){
            this.setState({
                tab: 1
            });
            document.title  = '听课记录'
        }else {
            this.setState({
                tab: 0
            });
            document.title  = '订单记录'
        }
    }

    componentWillReceiveProps(nextProps) {
        //如果从我的微课url直接进来就没有nextProps.route了  //给的我的微课/我买的课用的
        if(!nextProps.route){
            return
        }
        let {path} = nextProps.route;
        if (path === '/account/listened'){
            this.setState({
                tab: 1
            });
            document.title  = '听课记录'
        }else {
            this.setState({
                tab: 0
            });
            document.title  = '订单记录'
        }
    }

    handleBoughtLink() {
        if (this.state.tab === 0){
            return true
        }else {
            document.title  = '订单记录';
            this.setState({
                tab: 0,
                listenTop: document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
            },() => {
                location.assign('/account/bought');
                document.documentElement.scrollTop = document.body.scrollTop = this.state.boughtTop;
            })
        }
    }

    handleListenedLink() {
        if (this.state.tab === 1){
            return true
        }else {
            document.title  = '听课记录';
            this.setState({
                tab: 1,
                boughtTop: document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
            },() => {
                location.assign('/account/listened');
                document.documentElement.scrollTop = document.body.scrollTop = this.state.listenTop;
            })
        }
    }

    toPhoneEdit () {
        location.assign('/account/edit/phone')
    }

    isAlipayOrQq () {
        return isQQ() || isAlipay()
    }

    render() {
        return (
            <div className="record-page">
                {
                    isQQ() && (
                        <div className="classroom-top-app" style={{height: '44px'}} onClick={() => this.toPhoneEdit()}>
                            <div className="classroom-top-app_text">
                                下载APP接收课程提醒，课程永久回听
                            </div>
                        </div>
                    )
                }
                <TabBody>
                    <div style={{display: this.state.tab === 0 ? null : 'none', overflow: 'hidden'}}>
                        <BoughtList tab={this.state.tab}/>
                    </div>
                    <div style={{display: this.state.tab === 1 ? null : 'none'}}>
                        <ListenedList tab={this.state.tab}/>
                    </div>
                </TabBody>
            </div>
        )
    }
}

export default BoughtPage


// WEBPACK FOOTER //
// ./src/pages/BoughtPage/BoughtPage.js